import styled from 'styled-components';

export const ReportCellCommentContainer = styled.div`
  position: absolute;
  top: calc(50% - 13px);
  right: 8px;
  visibility: ${({ isAlwaysVisible }) => (isAlwaysVisible ? 'visible' : 'hidden')};

  @keyframes highlight {
    0% {
      box-shadow: 0 0 0 0 rgba(34, 139, 230, 0.4);
    }
    30% {
      box-shadow: 0 0 10px 4px rgba(34, 139, 230, 0.6);
    }
    70% {
      box-shadow: 0 0 10px 4px rgba(34, 139, 230, 0.6);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(34, 139, 230, 0);
    }
  }

  &.highlight-border {
    animation-name: highlight;
    animation-duration: 1.2s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: none;
    animation-iteration-count: 1;
    border-radius: 8px;
    overflow: hidden;
  }
`;

export const MessageContainer = styled.div`
  padding: 12px;
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 8px 8px 8px 0;
  width: 315px;
  box-shadow:
    0 7px 7px -5px rgba(0, 0, 0, 0.04),
    0px 10px 15px -5px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  user-select: auto;

  .body {
    margin: 8px 0 16px;
    color: #868e96;
    font-size: 14px;
    line-height: 20px;
  }
`;

export const MessageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #495057;
    font-size: 16px;
    line-height: 22px;
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-grow: 1;

    .unresolved-thread {
      margin-right: 5px;
    }
  }
`;

export const MessageFooter = styled.div`
  input {
    width: 100%;
    font-size: 14px;
    margin-top: 8px;
    margin-bottom: 16px;
    outline: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 8px;

    &:focus {
      border: 1px solid #228be6;
    }
  }
`;

export const CommentIconContainer = styled.div`
  padding: 4px 8px;
  cursor: pointer;
  border-radius: 8px 8px 8px 0;
  border: 1px solid #dee2e6;
  background: #fff;
  height: fit-content;
  box-shadow:
    0 7px 7px -5px rgba(0, 0, 0, 0.04),
    0px 0px 16px 2px rgba(0, 0, 0, 0.1),
    0px 0px 3px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;

  .comment-count {
    font-size: 12px;
    margin-right: 3px;
    color: #228be6;
    font-weight: 600;
  }
`;

export const AddCommentBtn = styled.button`
  padding: 4px 12px;
  margin: 0;
  border-radius: 4px;
  border: 1px solid #ced4da;
  transition: all 300ms ease;

  &:hover {
    border-color: #228be6;
  }
`;

export const ResolvedState = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2f9e44;
  font-size: 14px;
  margin-right: 5px;

  svg {
    margin-right: 3px;
  }
`;
